webpackJsonp([35783957827783],{

/***/ 119:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/cover.a603d399.jpg";

/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/logo-k.e8265713.png";

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _cover = __webpack_require__(119);
	
	var _cover2 = _interopRequireDefault(_cover);
	
	var _logoK = __webpack_require__(72);
	
	var _logoK2 = _interopRequireDefault(_logoK);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
		return _react2.default.createElement(
			"div",
			null,
			_react2.default.createElement(
				"div",
				{ style: {
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
						justifyContent: 'center',
						height: '70vh'
					} },
				_react2.default.createElement(
					"div",
					{ className: "landing-cover__logo" },
					_react2.default.createElement(
						"div",
						{ className: "landing-cover__logo__img" },
						_react2.default.createElement("img", {
							src: _logoK2.default,
							style: {
								minWidth: '150px'
							}
						})
					)
				),
				_react2.default.createElement(
					"div",
					{ className: "landing-cover__title" },
					_react2.default.createElement(
						"div",
						{ className: "landing-cover__logo-mobile" },
						_react2.default.createElement("img", {
							src: _logoK2.default,
							style: {
								width: '70px'
							}
						})
					),
					_react2.default.createElement(
						"h1",
						{ style: { color: 'white' } },
						"Vi\u1EC7t ph\u1ED1   "
					),
					_react2.default.createElement(
						"h1",
						{ style: { color: 'white', lineHeight: '4rem' } },
						" \\\u2019vi\u0259\u0330\u0294t\u02E8\u02E9 fo\u02E7\u02E5\u2019\\ "
					),
					_react2.default.createElement(
						"p",
						null,
						"Auf Deutsch die Stra\xDFen Vietnams. Dort ist Streetfood kein Trend sondern Kultur und Alltag. Ob in den Mittagspausen oder Abends mit Freunden oder der Familie, auf den Stra\xDFen wird gegessen. Mit Vietpho Cuisine bringen wir den unverf\xE4lschten Geschamk dieser Mainstream-Esskultur unseren Deutschen G\xE4sten ein St\xFCck n\xE4her. "
					),
					_react2.default.createElement(
						"ul",
						{ className: "icons" },
						_react2.default.createElement(
							"li",
							null,
							_react2.default.createElement(
								"a",
								{ style: { color: 'white' }, href: "https://www.facebook.com/VietPho-Cuisine-334073757070790/", className: "icon fa-facebook" },
								_react2.default.createElement(
									"span",
									{ className: "label" },
									"Facebook"
								)
							)
						),
						_react2.default.createElement(
							"li",
							null,
							_react2.default.createElement(
								"a",
								{ style: { color: 'white' }, href: "https://www.instagram.com/vietpho_cuisine/", className: "icon fa-instagram" },
								_react2.default.createElement(
									"span",
									{ className: "label" },
									"Instagram"
								)
							)
						)
					)
				)
			)
		);
	};
	
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-18bec5f346bf08c00468.js